export default function (context, {field, value}) {
    switch (field) {
        case 'CategoryId':
            context.commit('set', {
                CategoryId: value,
                PaymentTypeIds: [],
                CashList: [],
                PaymentAccountList: [],
            });
            break;
        case 'Contragent':
            let type = '';
            switch (value.type) {
                case 'client':
                    type = 1;
                    break;
                case 'partner':
                    type = 2;
                    break;
                case 'partnerLegal':
                    type = 3;
                    break;
            }
            context.commit('set', {
                ContragentId: value.value?value.value:'',
                ContragentName: value.label?value.label:'',
                ContragentSearchTypeId: type,
            });
            break;
        default:
            let d = {};
            d[field] = value;
            context.commit('set', d);
    }
}